import { isAfter, subDays } from 'date-fns'
import { parseDate } from '@ads/front-core/utils'

const UTM_EXPIRY_DAYS = 365
const UTM_FC_TIMESTAMP_KEY = 'fc_timestamp'

export const storeUTMSource = () => {
  if (!window.location.search) {
    return
  }

  try {
    const sourceUTMs = new URLSearchParams(
      window.localStorage.getItem('source') || '',
    )

    const search = new URLSearchParams(window.location.search)
    if (search?.get('utm_source') === 'samito') {
      sourceUTMs.set('utm_ma', search.get('utm_campaign'))
    }

    Array.from(search)
      .filter(s => s[0].match(/^utm_(source|campaign)/))
      .forEach(item => {
        if (sourceUTMs.get(item[0])) {
          const fcTimestamp = sourceUTMs.get(UTM_FC_TIMESTAMP_KEY)
          if (fcTimestamp) {
            if (
              isAfter(
                subDays(new Date(), UTM_EXPIRY_DAYS),
                parseDate(fcTimestamp),
              )
            ) {
              sourceUTMs.delete(item[0])
              sourceUTMs.delete(UTM_FC_TIMESTAMP_KEY)
            }
          } else {
            sourceUTMs.set(UTM_FC_TIMESTAMP_KEY, new Date().toISOString())
          }
        }
        if (!sourceUTMs.get(item[0])) {
          sourceUTMs.set(item[0], item[1])
          sourceUTMs.set(UTM_FC_TIMESTAMP_KEY, new Date().toISOString())
        }
        sourceUTMs.set(`lc_${item[0]}`, item[1])
      })

    const source = sourceUTMs.toString()
    if (source) {
      window.localStorage.setItem('source', source)
    }
  } catch (e) {
    console.error(e)
  }
}
